import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VBtn,_vm._g(_vm._b({staticClass:"font-weight-bold",attrs:{"color":_vm.color,"depressed":_vm.depressed,"min-width":_vm.minWidth,"tile":_vm.tile,"x-large":""}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }